import { Button } from '@/components/ui/button';
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogFooter,
	DialogClose,
} from '@/components/ui/dialog';
import { useTranslation } from 'react-i18next';
import useDeleteList from '../hooks/useDeleteList';
import { useNavigate, useParams } from 'react-router-dom';

type ListDeleteModalProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
};

const ListDeleteModal = ({ open, setOpen }: ListDeleteModalProps) => {
	const { t } = useTranslation();
	const { id_list } = useParams();
	const navigate = useNavigate();

	const { deleteList } = useDeleteList();

	if (!id_list) return null;

	return (
		<Dialog modal={true} open={open} onOpenChange={(open) => setOpen(open)}>
			<DialogContent className="max-w-[95%] sm:max-w-[425px]">
				<DialogHeader>
					<DialogTitle>{t('list.delete.title')}</DialogTitle>
					<DialogDescription>
						{t('list.delete.description')}
					</DialogDescription>
				</DialogHeader>
				<DialogFooter className="gap-3 pt-4 sm:gap-0">
					<DialogClose asChild>
						<Button className="w-full" variant="outline">
							{t('common.cancel')}
						</Button>
					</DialogClose>
					<DialogClose asChild>
						<Button
							className="w-full"
							variant="destructive"
							onClick={() => {
								deleteList({ id_list: parseInt(id_list) });
								navigate('/home');
							}}
						>
							{t('list.delete.action')}
						</Button>
					</DialogClose>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default ListDeleteModal;
